import { useEffect, type RefObject } from "react";

export const useClickOutsideModalListener = (
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
) => {
  useEffect(() => {
    const wrappedCallback = (evt: MouseEvent) => {
      if (ref.current && !ref.current.contains(evt.target as Node)) {
        callback();
      }
    };
    document.addEventListener("mouseup", wrappedCallback);
    return () => {
      document.removeEventListener("mouseup", wrappedCallback);
    };
  }, [ref]);
};
